<template>
  <div>
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <LKMunMehFormReview
      v-else
      :mun-meh="single"
      :form-id="formId"
      :slug="slug"
      :topic-slug="topicSlug"
      :levels="levels"
    />
  </div>
</template>

<script>
import LKMunMehExpertView from '@/views/LKMunMeh/Review/LKMunMehExpertView.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehFormReview from '@/views/LKMunMeh/ReviewSecond/components/LKMunMehReviewSecondForm.vue'

export default {
  name: 'LKMunMehFormView',
  components: {
    LKProgressCircular,
    LKMunMehFormReview,
  },
  extends: LKMunMehExpertView,
}
</script>

